define('shoptheme/components/blocks/fce/elements/videotutorials',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"videojs",
	"videojs",
	"cartware/components/Dispatcher",
	"videojs-vimeo",
	"videojs-youtube",
	"magnific-popup"
], function(
	$,
	Component,
	BEM,
	videojs,
	ComponentDispatcher
) {
	var BLOCK_NAME = "csp-support-detail-videotutorials";

	return Component.create({
		blocks:			null,
		$init: function() {
			var self = this;

			this.blocks = BEM.block(BLOCK_NAME);
			this.blocks.each(function() {
				var block = BEM.block(this),
					title = block.getElements("title"),
					reel =  block.getElements("sources-list"),
					firstElement = reel.find('a').first();

				reel.find("[data-video-sources]").click(function(e){
					e.preventDefault();
					elem = $(this);
					self.setVideo(elem, block, true);
					self.scrollToVideo(block);
				});

				self.setVideo(firstElement, block, false);

			});
		},
		
		setVideo: function(source, rootBlock, start){
			var sources = source.data('video-sources'),
				currentVideo = rootBlock.find('.b_video-widget');

			if (currentVideo.length) {
				if (currentVideo.find('.video-js').length) {
					videojs(currentVideo.find('.video-js').get(0)).dispose();
					currentVideo.html('');
				}
			}
			var newVideo = $('<video controls class="video-js vjs-gigaset-tutorials vjs-16-9"></video>').appendTo(rootBlock.find('.b_video-widget'));

			if (sources.type == "video/youtube") {
				videojs.options.techOrder = ['youtube'];
			} else {
				videojs.options.techOrder = ['html5'];
			}
			videojs(newVideo.get(0), {} , function() {
				var player = this;
				rootBlock.getElements("sources-list").find('a').removeClass('currently-playing');
				player.src(sources);
				rootBlock.getElements("video-title").html(source.attr('title'));
				rootBlock.getElements("video-description").html(source.data('video-description'));
				player.poster(source.find('img').attr('src'));
				source.addClass('currently-playing');
				if (start) {
					player.play();
				}
			});

		},

		scrollToVideo: function(block){
			var offset = block.offset().top - $(window).scrollTop();

			if(offset < 0){
				$('html,body').animate({scrollTop: block.offset().top}, 1000);
				return false;
			}
			return true;
		}
	});
});
